import { Animation } from 'blaze-components/Animations/Animation'
import analyzing from './analyzing.json'
import transcribing from './transcribing.json'
import finalizing from './finalizing.mp4'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './Processing.module.scss'
import { clamp } from 'lodash'
import { Button } from 'blaze-ui/Button'

interface Props {
  step: number
  onCancel: () => void
}

export const Processing = ({ step: propsStep = 0, onCancel }: Props) => {
  const step = clamp(propsStep, 0, 2)
  const animationProps = { play: true, style: { width: 85, height: 85 } }

  return (
    <div className={Styles.content}>
      <div />
      <div className={Styles.animation}>
        {step === 0 && (
          <>
            <Animation animationData={analyzing} {...animationProps} />
            <Text variant="primary">Analyzing source...</Text>
          </>
        )}
        {step === 1 && (
          <>
            <Animation animationData={transcribing} {...animationProps} />
            <Text variant="primary">Extracting tone...</Text>
          </>
        )}
        {step === 2 && (
          <>
            <video width="100%" autoPlay muted playsInline height={85} loop>
              <source src={finalizing} type='video/mp4; codecs="hvc1" ' />
              <source src={finalizing} type="video/webm" />
            </video>
            <Text variant="primary">Finalizing brand voice...</Text>
          </>
        )}
      </div>
      <div className={Styles.buttonContainer}>
        <Button variant="tertiary" onPress={onCancel} size="lg">
          Cancel
        </Button>
      </div>
    </div>
  )
}
